import { Navigate, Outlet } from 'react-router-dom'
import { DASHBOARD_HOME } from '@yourownmetric/shared'

import { useAppSelector } from '@/app/hooks'

export function RequireSuperAdmin() {
    const user = useAppSelector(s => s.auth.user)

    if (!user?.isSuperAdmin) {
        return <Navigate to={DASHBOARD_HOME} replace />
    }

    return <Outlet />
}
